import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IConnectedApplicationType } from '../types/ConnectedApplicationType';


function UpdateConnectedApplicationConfig(id: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'PUT',
    endpoint: `connected-applications/${id}`,
    serverWideRequest: false
  };
}

// Backend is the source of truth for when things are created, not us
export type UpdateConnectedApplicationType = Omit<IConnectedApplicationType, 'createdAt'>;
export interface UpdateConnectedApplicationParams {
  connectedApplication: UpdateConnectedApplicationType;
}

export interface UpdateConnectedApplicationResult {
  error?: unknown;
  connectedApplication?: IConnectedApplicationType;
}

export function callUpdateConnectedApplication(request: UpdateConnectedApplicationParams): Promise<UpdateConnectedApplicationResult> {
  return makeJsonRestApiRequest<UpdateConnectedApplicationParams, UpdateConnectedApplicationResult>({
    config: UpdateConnectedApplicationConfig(request.connectedApplication.clientId),
    request,
  });
}